"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadPayload = exports.FetchPayload = exports.FetchPayloadActionTypes = exports.PayloadActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var PayloadActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_PAYLOAD: null,
  FETCH_PAYLOAD: null
}, 'shared');
exports.PayloadActionTypes = PayloadActionTypes;
var FetchPayloadActionTypes = (0, _actions.createRequestTypes)(PayloadActionTypes.FETCH_PAYLOAD);
exports.FetchPayloadActionTypes = FetchPayloadActionTypes;
var FetchPayload = (0, _actions.createRequestActions)(FetchPayloadActionTypes);
exports.FetchPayload = FetchPayload;
var loadPayload = (0, _fluxActions.createAction)(PayloadActionTypes.LOAD_PAYLOAD);
exports.loadPayload = loadPayload;